import { Box, BoxProps } from '@chakra-ui/react'
import React, { memo, FC } from 'react'

export type LogoProps = BoxProps

export const Logo: FC<LogoProps> = memo((props) => {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="30 30 565.2 286"
        xmlSpace="preserve"
        width="100%"
      >
        <switch>
          <g>
            <path
              fill="currentColor"
              d="M347.3 146.5v146.2H406V138.5c-25.9 12.3-50.4 9.5-58.7 8zM534 49.4h-81.7l-31.8 243.3H478l9.6-69.3 15.7 1.9 12.5 67.4h57.3L534 49.4zm-52 131.8 11.9-74.6 14.1 78.2-26-3.6zM117.7 158.9v23.3l28.6 8.4v19.9s-12.4 17.2-36.2 6.9c-15.7-6.9-22.1-65.5-3.8-78.6 14.3-10.2 62.3-6.4 73.1-5.6V79.5C174.5 69 145 43.6 105.9 48.1c-16.4 1.9-27.7 6-39.8 15.5-17.5 13.7-20.5 31.8-22.5 51.7-2.2 21.3-1.5 42.8-1.3 64.2.2 19.2-.1 38.4 2.3 57.5 2.1 16.9 5.9 33.9 21.5 46.2 12.1 9.5 23.3 13.8 39.8 15.1 46.2 3.7 70.2-23.7 75-34.1L170.2 159h-52.5zM347.3 116.2s9.6 2.6 23.3 3.1c13.6.4 35.4-8.2 35.4-8.2V49.4h-58.7v66.8zM292.5 85.8c.2-1.1-9.3-42.3-49.8-37.9-11.7 1.3-19.7 5.5-28.3 14.6-12.4 13.2-14.7 34.2-16 52.2-1.6 20.7-1.7 41.4-1.6 62.1.1 18.6.6 37.2 2.3 55.7 1.5 16.3 4.2 35.1 15.3 46.9 8.6 9.2 16.6 13.4 28.3 14.6 40.5 4.4 50-36.8 49.8-37.9l6 36.4h26.6V49.2h-26.5c0 .2-6.1 36.5-6.1 36.6zm-54.4 130.9s.4-62 .9-68 .5-20.1 10.3-20.3c9.7-.2 9.5 13.5 10.6 21.2 1.7 11.7 1.7 67.1 1.7 67.1h-23.5z"
            />
          </g>
        </switch>
      </svg>
    </Box>
  )
})
